let currentNonce: string | null = null;

export function setNonce(value: string | null | undefined): void {
  if (typeof value === 'string' && value.length > 0) {
    currentNonce = value;
  }
}

export function getNonce(): string | null {
  return currentNonce;
}

export function clearNonce(): void {
  currentNonce = null;
}
